<div class="p-grid p-jc-center">
    <div class="p-lg-8">
        <h3 class="titulo">{{'PREGUNTAS.FRECUENTES'|translate}}</h3>
        <p-accordion>
            <p-accordionTab [header]="'GLOBAL.QUE.ES.DUMINVAL' |translate" [selected]="true">
               <div [innerHtml]="'GLOBAL.RESPUESTA.QUE.ES.DUMINVAL'|translate"></div>
            </p-accordionTab>
            <p-accordionTab [header]="'GLOBAL.COMO.FUNCIONA' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.COMO.FUNCIONA'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.QUIEN.PUEDE.ESTACIONAR' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.QUIEN.PUEDE.ESTACIONAR'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOANL.DONDE.PUEDO.DESCARGAR' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.DONDE.PUEDO.DESCARGAR'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.TIENE.ALGUN.COSTE' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.TIENE.ALGUN.COSTE'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.DESAPARECE.EL.DISCO.DE.CONTROL.HORARIO' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.DESAPARECE.EL.DISCO.DE.CONTROL.HORARIO'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.PUEDO.CONSULTAR.HISTORIAL.SESIONES' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.PUEDO.CONSULTAR.HISTORIAL.SESIONES'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.HAGO.INCIDENCIA.TECNICA' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.HAGO.INCIDENCIA.TECNICA'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.QUE.TIPOS.USUARIOS.EXISTEN' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.QUE.TIPOS.USUARIOS.EXISTEN'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.TIPOS.PLAZAS.HAY' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.TIPOS.PLAZAS.HAY'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.COMO.REGISTRO' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.COMO.REGISTRO'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.HAY.QUE.REGISTRARSE' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.HAY.QUE.REGISTRARSE'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.ME.TENGO.QUE.REGISTRAR.SI.SOY.USUARIO.DISCO.CONTROL' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.ME.TENGO.QUE.REGISTRAR.SI.SOY.USUARIO.DISCO.CONTROL'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.ME.TENGO.REGISTRAR.SI.SOY.PMR' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.ME.TENGO.REGISTRAR.SI.SOY.PMR'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.ME.TENGO.REGISTRAR.SI.SOY.OVE' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.ME.TENGO.REGISTRAR.SI.SOY.OVE'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.QUE.PASA.SI.NO.RECUERDO.MI.CONTRASEÑA' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.QUE.PASA.SI.NO.RECUERDO.MI.CONTRASEÑA'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.SI.QUIERO.DARME.DE.BAJA' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.SI.QUIERO.DARME.DE.BAJA'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.SI.QUIERO.DAR.DE.BAJA.VEHICULO' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.SI.QUIERO.DAR.DE.BAJA.VEHICULO'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.COMO.ACTUARA.CONTROLADOR.ORA.SIN.DISCO.EN.EL.INTERIOR' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.COMO.ACTUARA.CONTROLADOR.ORA.SIN.DISCO.EN.EL.INTERIOR'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.ESTABLECER.MI.RUTA.ENTREGAS' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.ESTABLECER.MI.RUTA.ENTREGAS'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.PUEDO.REGISTRAR.MAS.DE.UN.VEHICULO' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.PUEDO.REGISTRAR.MAS.DE.UN.VEHICULO'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.PUEDE.OTRO.USUARIO.UTILIZAR.MI.VEHICULO' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.PUEDE.OTRO.USUARIO.UTILIZAR.MI.VEHICULO'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.PUEDO.APARCAR.VARIOS.VEHICULOS.A.LA.VEZ' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.PUEDO.APARCAR.VARIOS.VEHICULOS.A.LA.VEZ'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.SE.PUEDE.PRORROGAR.TICKET' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.SE.PUEDE.PRORROGAR.TICKET'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.COMO.CONFIGURAR.AVISO.FINALIZACION.TICKET' |translate" >
                <div [innerHtml]="'GLOBAL.RESPUESTA.COMO.CONFIGURAR.AVISO.FINALIZACION.TICKET'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.PUEDO.ANULAR.DENUNCIA' |translate" >
                <div [innerHtml]="'GLOBAL.RESPUESTA.PUEDO.ANULAR.DENUNCIA'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.TIEMPO.MAXIMO.ESTACIONAMIENTO' |translate" >
                <div [innerHtml]="'GLOBAL.RESPUESTA.TIEMPO.MAXIMO.ESTACIONAMIENTO'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.PREDICION.PLAZAS' |translate" >
                <div [innerHtml]="'GLOBAL.RESPUESTA.PREDICION.PLAZAS'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.SI.TODAVIA.NO.TENGO.IMPUESTO.TRACCION.MECANICA' |translate">
                <div [innerHtml]="'GLOBAL.RESPUESTA.SI.TODAVIA.NO.TENGO.IMPUESTO.TRACCION.MECANICA'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.SI.EL.VEHICULO.ESTA.REGISTRADO.POR.PROPIETARIO.ANTERIOR' |translate" >
                <div [innerHtml]="'GLOBAL.RESPUESTA.SI.EL.VEHICULO.ESTA.REGISTRADO.POR.PROPIETARIO.ANTERIOR'|translate"></div>
             </p-accordionTab>
             <p-accordionTab [header]="'GLOBAL.DONDE.COLOCAR.DISTINTIVO.AMBIENTAL' |translate" >
                <div [innerHtml]="'GLOBAL.RESPUESTA.DONDE.COLOCAR.DISTINTIVO.AMBIENTAL'|translate"></div>
             </p-accordionTab>
        </p-accordion>
    </div>
</div>

